module.exports = __webpack_public_path__ + "img/fun_edition.e36c017b.png";